module.exports = __webpack_public_path__ + "img/MemeETC (7).99b648f4.jpeg";